// An toàn thương hiệu (brand safety) cho quảng cáo Native — Mức 1 (lọc từ khoá, không cần AI).
// Không chèn quảng cáo cạnh bài có nội dung tiêu cực/nhạy cảm (tai nạn, tang sự, bạo lực, 18+, lừa đảo…).
// So khớp KHÔNG dấu (chuẩn hoá bỏ dấu) để bắt cả biến thể có/không dấu. Có thể chuyển sang System Settings sau.

const stripAccents = (s: string): string =>
  (s || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase();

// Từ/cụm khoá nhạy cảm (đã bỏ dấu). Chỉnh danh sách này để tinh chỉnh độ chặt.
export const SENSITIVE_KEYWORDS: string[] = [
  // Tai nạn / thương vong / tang sự
  'tai nan', 'tu vong', 'thiet mang', 'qua doi', 'thi the', 'tu tu', 'tang le', 'dam tang', 'chia buon', 'phung dieu',
  // Bạo lực / tội phạm
  'giet nguoi', 'giet hai', 'cuop', 'hiep dam', 'bao luc', 'danh nhau', 'khung bo', 'no sung', 'dam chem', 'bat coc',
  // Ma tuý / tệ nạn
  'ma tuy', 'heroin', 'ca do', 'ca cuoc', 'danh bac',
  // Thiên tai / thảm hoạ
  'dong dat', 'sat lo', 'lu lut', 'chay nha', 'hoa hoan', 'thien tai', 'tham hoa',
  // Dịch bệnh
  'dich benh', 'covid',
  // 18+ / nhạy cảm
  'khieu dam', 'phim sex', 'nong bong', 'lo hang', '18+',
  // Lừa đảo
  'lua dao', 'scam', 'chiem doat',
  // Chính trị nhạy cảm
  'bieu tinh', 'phan dong',
];

/**
 * true = bài AN TOÀN để đặt quảng cáo bên cạnh; false = nội dung nhạy cảm → KHÔNG chèn ads.
 * Ghép các trường văn bản của bài rồi dò từ khoá nhạy cảm.
 */
export function isAdSafeContent(post: any): boolean {
  if (!post) return true;
  // Mức 2 (SmartAds) — nhãn cảm xúc do AI phân loại sẵn (Post.AdSentiment). Có key OpenAI thì bài đã được
  // gắn nhãn; Negative/Sensitive → không đặt quảng cáo. Bài chưa gắn nhãn (null) → rơi xuống lọc từ khoá Mức 1.
  const sentiment = String(post.adSentiment || '').toLowerCase();
  if (sentiment === 'negative' || sentiment === 'sensitive') return false;
  const text = stripAccents(
    [post.title, post.content, post.description, post.hashtags, post.categoryName]
      .filter(Boolean)
      .join(' ')
  );
  if (!text) return true;
  return !SENSITIVE_KEYWORDS.some((kw) => text.includes(kw));
}
